import { Swiper, Navigation, Pagination, Autoplay } from "swiper/bundle";
export default class HeroSwiper {
    constructor() {
        console.log('%c👍🏼 Hero Swiper VS', 'color: yellow');
        this.heroSwiper = document.querySelectorAll(
            '.swiper--hero'
        ) 
    }
    init() {
        this.heroSwiper.forEach((elem, i) => {
        
            let slides = elem.querySelectorAll('.swiper-slide');
            if (slides.length > 1)
            {
                let swiper = new Swiper(elem, {
                    slidesPerView: 1,
                    loop: false,
                    pauseOnMouseEnter: true,
                    effect: 'fade',
                    simulateTouch:false,
                    fadeEffect: {
                        crossFade: false
                      },
                    //spaceBetween: 10,
                    // pagination: {
                    //     el: '.swiper-pagination',
                    //     clickable: true
                    // },
                    navigation: {
                        nextEl: elem.querySelector(".swiper-button-next"),
                        prevEl: elem.querySelector(".swiper-button-prev"),
                    },
                });   

                swiper.on('slideChange', function () {
                    let videos = elem.querySelectorAll('video');
                    videos.forEach((video) => {
                        video.currentTime = 0;
                    })
                });
            } 
        });        
    }
}